import { Link } from '@ets-global/b2c-website-ui';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import { SmallTitle } from '../../../components/Base/Title';
import { useBasketCookie, useRouter } from '../../../hooks';
import { paths } from '../../../paths';
import CandidateWidget from '../Register/Candidate/Widget';
import CandidateWidgetSkeleton from '../Register/Candidate/Widget/CandidateWidgetSkeleton';

const Candidates = ({
  candidates,
  productsAndServices,
  sessionId,
  withPicture,
  withDateOfBirth,
  hasVoucher = false,
  notEditable = false,
}) => {
  const history = useHistory();
  const { generatePath } = useRouter();
  const { t } = useTranslation();
  const { getBasket } = useBasketCookie();
  const registrationId = getBasket();

  const params = { sessionId: sessionId, registrationId };

  return (
    <div className="basket__block basket__block--candidates">
      <SmallTitle>
        <Trans count={candidates.length} values={{ count: candidates.length }}>
          session-summary.candidates.title
        </Trans>
      </SmallTitle>
      <Link
        to={paths.SESSION_REGISTER_BY_REGISTRATION_ID}
        params={params}
        aria-label={t('session-summary.candidates.back')}
      >
        <Trans>session-summary.candidates.back</Trans>
      </Link>

      {candidates.map((candidate, key) =>
        !productsAndServices ? (
          <CandidateWidgetSkeleton key={key} />
        ) : (
          <CandidateWidget
            key={key}
            order={key}
            candidate={candidate}
            hasVoucher={hasVoucher && key === 0}
            notEditable={notEditable}
            onOpen={() =>
              history.push(generatePath(paths.SESSION_REGISTER_BY_REGISTRATION_ID, params), {
                identificationId: candidate.identificationId,
              })
            }
            sessionId={parseInt(sessionId, 10)}
            withPicture={withPicture}
            withDateOfBirth={withDateOfBirth}
            displayOnly={true}
            productsAndServices={productsAndServices}
          />
        )
      )}
    </div>
  );
};

Candidates.propTypes = {
  candidates: PropTypes.array.isRequired,
  sessionId: PropTypes.string.isRequired,
  registrationId: PropTypes.string.isRequired,
  withPicture: PropTypes.bool.isRequired,
  withDateOfBirth: PropTypes.bool.isRequired,
};

export default Candidates;
